import React from "react";
import styles from "./WhyChooseAptech.module.scss";
import WhyChooesAptechAboutUs from "../../../assets/images/WhyChooesAptechAboutUs.jpg";
import AbousWhychooseAptechBanner2 from "../../../assets/images/AbousWhychooseAptechBanner2.png";
import industriTraining from "../../../assets/images/IndustriTraining.jpg";
import PlacementGuidanceImg from "../../../assets/images/placementGuideImgNew.jpg";
import AptechAimsCard from "../../CustomComponent/AptechAimsCard.tsx";
import ImageTextSection from "../../CustomComponent/ImageTextSection.tsx";
import BreadCrumb from "../../CommonComponents/BreadCrumb.tsx";
import { Icon } from "../../../assets/Icons.tsx";

const items: string[] = [
  "Aptech is a trusted leader in skill-based and vocational education.",
  "Has over 39 years of experience in training millions of students worldwide. ",
  "Offers industry-relevant courses in IT, animation, VFX, aviation, hospitality, beauty and wellness, and finance. ",
  "A dedicated placement cell offering job assistance and industry connections. ",
  "Expert faculty offering mentorship to succeed in this competitive age. ",
  `Institutional Business (EBG) providing assessment and testing solutions to government, private, and autonomous clients.`,
  "Delivers high-quality training to make students industry-ready upon course completion. ",
];
interface DataItem {
  src: string;
  title: string;
  description: string;
}
const data: DataItem[] = [
  {
    src: "Rocket",
    title: "Mission",
    description:
      "Aptech Limited – a trusted, self-reliant and widely recognized Indian brand, with global footprint delivering vocational training, skilling, and non-formal education to students, professionals, universities, and corporates, aiming to create and foster an ecosystem where youth are skilled, trained, and prepared for successful employment or entrepreneurship.  ",
  },
  {
    src: "Vision",
    title: "vision",
    description:
      "To be the preferred learning solutions company offering vocational training, skilling and non-formal education, and make our students highly employable and job-ready with our industry relevant course curriculum.  ",
  },
];

interface DataItemWorkForce {
  src: string;
  text: string;
}
const workforce: DataItemWorkForce[] = [
  {
    src: "Collaboration",
    text: "Promoting industry collaborations",
  },
  {
    src: "flexibleLearning",
    text: "Introducing diverse and flexible learning methodologies",
  },
  {
    src: "programCurriculam",
    text: "Crafting industry-driven program curriculum",
  },
  {
    src: "industryScenario",
    text: "Allowing students to apply learning in industry-relevant scenarios",
  },
  {
    src: "learningPlatform",
    text: "Integrating cutting-edge technologies like AI and digital learning platforms",
  },
  {
    src: "workSpace",
    text: "Empowering individuals with skills they need to succeed in their workplace",
  },
];

const WhyChooseAptech: React.FC = () => {
  const breadcrumb = [
    { title: "Home", link: "/" },
    { title: "About Us", link: "/about-us" },
    { title: "Why Choose Aptech", link: "" },
  ];
  return (
    <div id="WhyAptechPage" className={`${styles.whyAptechPage}`}>
      <BreadCrumb menu={breadcrumb} />
      <Banner />
      <WhyAptechListView />
      <MissionVisionSection />
      <div className="container">
        <IndustriOrientedSection />
        <AimsCardSection />
        <PlacementGuidanceSection />
        <PlacementPreparationSection />
      </div>
    </div>
  );
};

const Banner = () => {
  const content = [
    `Aptech is a global leader in skill-based education for students and professionals.`,
    `Over the years, it has expanded into sectors such as IT training,media and entertainment, retail, aviation, beauty and wellness, finance, and pre-school education.`,
    `With a strong focus on industry-relevant training, Aptech
     empowers students to launch their own businesses, build a
     strong professional network, and create a sustainable
     career. It equips them with the skills and expertise needed
     to thrive as independent entrepreneurs and successful
     freelancers.`,
  ];
  return (
    <div className="container">
      <div className="mb-5">
        <div className="row mt-5">
          <div className="col-12">
            <ImageTextSection
              imageSrc={WhyChooesAptechAboutUs}
              imageAlt="WhyAptech Image"
              content={content}
              heading="Why Choose Aptech"
              reverse={true}
              imageAlign="center"
              imageAlignInMob="center"
              imageHeightTablet="25rem"
              imageHeight="22rem"
            />
          </div>
        </div>
      </div>
    </div>
  );
};
const WhyAptechListView = () => {
  return (
    <div className="container-fluid">
      <div className="section">
        <div className={`row ${styles.listBox} g-0`}>
          <div className="col-12">
            <div className="container">
              <div className="row g-0">
                <div
                  className={`col-lg-8  col-md-12 col-sm-12 col-xl-7 d-flex justify-content-center`}
                >
                  <ul className="mt-4" style={{paddingLeft:'15px'}}>
                    {items.map((item, index) => (
                      <li key={index} className={`para`}>
                        <p className={``}>{item}</p>
                      </li>
                    ))}
                  </ul>
                </div>

                <div
                  className={`col-lg-4 col-md-12 col-sm-12 col-xl-5 align-items-stretch ${styles.imgDiv}`}
                >
                  <img
                    src={AbousWhychooseAptechBanner2}
                    alt="AptechImage"
                    className={`img-fluid ${styles.AbousWhychooseAptechBanner2}`}
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
const MissionVisionSection = () => {
  return (
    <div className="container">
      <div className="section">
        <div className={`row g-2`}>
          {data.map((item, index) => (
            <div
              key={index}
              className=" col-md-12 col-lg-6 col-sm-12 mb-4 d-flex"
            >
              <div className={styles.missionVisionSection}>
                <div className="row mb-2">
                  <div className="col-6 d-flex justify-content-start align-items-end">
                    <h6 className="heading mb-0">{item.title}</h6>
                  </div>
                  <div className="col-6 d-flex justify-content-end align-items-end">
                    <Icon name={item.src} width="150px" height="150px" />
                  </div>
                </div>
                <div className="row">
                  <p className="para pt-3">{item.description}</p>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};
const IndustriOrientedSection = () => {
  return (
    <div className="section">
      <div className={`row ${styles.IndustryOrientedSection}`}>
        <div className="col-12">
          <div className={`row ${styles.IndustrialSectionDiv}`}>
            <div className="col-lg-8 col-md-12 col-sm-12 d-flex justify-content-center position-relative">
              <div className={styles.innerDiv}>
                <p className="heading">Industry-oriented Training</p>
                <p className="para">
                  The rapidly growing job market demands a skilled workforce.
                  And formal education often fails to keep pace with the
                  changing demands of various industries. To ease the stress on
                  the education system and to ensure high-quality{" "}
                  <strong>industry-aligned training</strong>, the vocational
                  training sector has stepped in.
                </p>
                <p className="para">
                  For over 39 years, Aptech has trained more than 7.5 million
                  students worldwide across sectors ranging from IT training,
                  media and entertainment, retail and aviation, beauty and
                  wellness, banking and finance, and pre-school segment. It has
                  also emerged as a frontrunner in vocational education with a
                  proven track record of anticipating{" "}
                  <strong>industry trends</strong> and turning those into
                  accessible and{" "}
                  <strong>industry-relevant training programs</strong>.
                </p>
              </div>

              <div className={styles.borderSection} />
            </div>
            <div className="col-lg-4 col-md-12 col-sm-12 d-flex justify-content-end align-items-end">
              <img
                src={industriTraining}
                alt="AptechImage"
                className={`img-fluid ${styles.IndustrialImage}`}
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
const AimsCardSection = () => {
  return (
    <div className="section">
      <div className={`row`}>
        <div className="col-12">
          <AptechAimsCard
            title="Aptech aims to build tomorrow’s workforce by:"
            workforce={workforce}
            contentPadding={true}
          />
        </div>
      </div>
    </div>
  );
};
const PlacementGuidanceSection = () => {
  return (
    <div>
      <div className="row g-0">
        <div
          className={`col-md-12 col-lg-6 col-sm-12 ${styles.placementGuidanceBox}`}
        >
          <p className="heading">Placement Guidance</p>
          <p className="para">
            The Industry Connects, Alliances, and Placements (ICAP) division at
            Aptech plays a pivotal role in bridging the gap between institutions
            and industries.
          </p>
          <p className="para">
            With more than 3 decades of industry engagement, Aptech has
            cultivated robust relationships with organisations, providing
            students with access to employment opportunities. {" "}
          </p>
          <p className="para">
            The focus on skill development coupled with strong industry
            connections creates a holistic approach to career advancement. {" "}
          </p>
        </div>
        <div className={`col-md-12 col-lg-6 col-sm-12 ${styles.imgBox}`}>
          <img
            src={PlacementGuidanceImg}
            alt="careerGuideImage"
            className={`img-fluid ${styles.PlacementGuidanceImg}`}
          />
        </div>
      </div>
    </div>
  );
};
const PlacementPreparationSection = () => {
  return (
    <div className="row mt-5">
      <div className="col-md-12 col-lg-6 col-sm-12">
        <p className="para mb-0">
          The Placement Preparation Program (PPP) at Aptech equips students for
          job success through:
        </p>

        <ul className={styles.listDiv}>
          <li className="para mb-0">
            <strong>Industry exposure </strong>
          </li>
          <li className="para mb-0">
            <strong>Mock interview sessions </strong>
          </li>
          <li className="para mb-0">
            <strong>Real-world internships </strong>
          </li>
          <li className="para mb-0">
            <strong>Career guidance programs</strong>
          </li>
        </ul>
      </div>
      <div className="col-md-12 col-lg-6 col-sm-12">
        <p className="para">
          ICAP has successfully facilitated several industry collaborations and
          job placements across Aptech brands like{" "}
          <strong>
            MAAC, Arena Animation, Lakmé Academy Powered by Aptech, Aptech
            Learning, and Avalon Academy
          </strong>
          .
        </p>
        <p className="para mt-4">
          ICAP will strengthen industry partnerships, expand its placement
          network, and innovate career programs to give learners a competitive
          edge in the evolving job market.
        </p>
      </div>
    </div>
  );
};
export default WhyChooseAptech;
